import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'app-markdown-content',
  standalone: true,
  imports: [MarkdownComponent],
  templateUrl: './markdown-content.html',
  styleUrl: './markdown-content.css',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'block min-w-0 max-w-full' },
})
export class MarkdownContent {
  @Input({ required: true }) content = '';
  @ViewChild('container', { read: ElementRef }) private container?: ElementRef<HTMLElement>;

  protected enhanceRenderedContent(): void {
    const container = this.container?.nativeElement;
    if (!container) return;

    for (const table of Array.from(container.querySelectorAll('table'))) {
      if (table.parentElement?.classList.contains('markdown-table-wrapper')) continue;
      const wrapper = document.createElement('div');
      wrapper.className = 'markdown-table-wrapper';
      table.parentNode?.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    for (const link of Array.from(container.querySelectorAll<HTMLAnchorElement>('a[href]'))) {
      try {
        const url = new URL(link.href, window.location.href);
        if ((url.protocol === 'http:' || url.protocol === 'https:') && url.origin !== window.location.origin) {
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }
      } catch {
        // Invalid and unsafe URLs are removed by Angular's sanitizer.
      }
    }
  }
}
